// import { BlankLayout, RouteView } from '@/layouts'
import { RouteView } from '@/layouts'
// import { component } from 'vue/types/umd'
// import { RouteView, SimpleLayout } from '@/layouts'

export const asyncRouterMap = [
  {
    path: '/user',
    component: RouteView,
    redirect: '/user/index',
    meta: { permission: ['user'] },
    children: [
      {
        path: 'index',
        name: 'UserIndex',
        component: () => import('../views/user/Index.vue'),
        meta: {
          title: '用户基本信息',
          permission: ['user']
        }
      },
      {
        path: 'work-order',
        name: 'UserWorkOrder',
        component: () => import('../views/user/WorkOrder.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '工单',
          permission: ['user']
        }
      },
      {
        path: 'work-order-details/:id',
        name: 'UserWorkOrderDetails',
        component: () => import('../views/user/WorkOrderDetails.vue'),
        props: true,
        meta: {
          title: '工单详情',
          permission: ['user']
        }
      },
      {
        path: 'worksheet-post',
        name: 'UserWorksheetPost',
        component: () => import('../views/user/WorksheetPost.vue'),
        meta: {
          title: '新建工单',
          permission: ['user']
        }
      },
      {
        path: 'add-child',
        name: 'UserAddChild',
        component: () => import('../views/user/AddChild.vue'),
        props: (route) => ({ id: route.params.id }), // 接受路由传参并且传送到页面中去，这样才能在页面的props接收
        meta: {
          title: '添加孩子',
          permission: ['user']
        }
      },
      {
        path: 'add-child1',
        name: 'UserAddChild1',
        component: () => import('../views/user/AddChild1.vue'),
        props: (route) => ({ id: route.params.id }),
        meta: {
          title: '添加孩子',
          permission: ['user']
        }
      },
      {
        path: 'withdraw-deposit',
        name: 'CashWithdrawal',
        component: () => import('../views/user/WithdrawDeposit.vue'),
        meta: {
          title: '提现',
          permission: ['user']
        }
      },
      {
        path: 'withdrawal-records',
        name: 'UserWithdrawalRecords',
        component: () => import('../views/user/WithdrawalRecords.vue'),
        meta: {
          title: '提现记录',
          permission: ['user']
        }
      },
      {
        path: 'order',
        name: 'UserOrder',
        component: () => import('../views/user/Order.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '用户订单列表',
          permission: ['user']
        }
      },
      {
        path: 'setting',
        name: 'UserSetting',
        component: () => import('../views/user/Setting.vue'),
        meta: {
          title: '设置',
          permission: ['user']
        }
      },
      {
        path: 'setting-email',
        name: 'UserSettingEmail',
        component: () => import('../views/user/SettingEmail.vue'),
        meta: {
          title: '绑定邮箱',
          permission: ['user']
        }
      },
      {
        path: 'setting-phone',
        name: 'UserSettingPhone',
        component: () => import('../views/user/SettingPhone.vue'),
        meta: {
          title: '绑定手机',
          permission: ['user']
        }
      },
      {
        path: 'setting-wechat',
        name: 'UserSettingWechat',
        component: () => import('../views/user/SettingWechat.vue'),
        meta: {
          title: '绑定微信',
          permission: ['user']
        }
      },
      {
        path: 'realname',
        name: 'UserSettingRealname',
        component: () => import('../views/user/SettingRealname.vue'),
        meta: {
          title: '实名认证',
          permission: ['user']
        }
      },
      {
        path: 'setting-password',
        name: 'UserSettingPassword',
        component: () => import('../views/user/SettingPassword.vue'),
        meta: {
          title: '设置密码',
          permission: ['user']
        }
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('../views/user/Profile.vue'),
        meta: {
          title: '个人信息',
          permission: ['user']
        }
      },
      {
        path: 'order',
        name: 'UserOrder',
        component: () => import('../views/user/Order.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '用户订单列表',
          permission: ['user']
        }
      },
      {
        path: 'order-details/:ordernum',
        name: 'UserOrderDetails',
        component: () => import('../views/user/OrderDetails.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }), // 解耦合
        meta: {
          title: '订单详情',
          permission: ['user']
        }
      },
      {
        path: 'order-cancel/:ordernum',
        name: 'UserOrderCancel',
        component: () => import('../views/user/OrderCancel.vue'),
        props: true,
        meta: {
          title: '订单取消申请',
          permission: ['user']
        }
      },
      {
        path: 'order-canceling/:ordernum',
        name: 'UserOrderCanceling',
        component: () => import('../views/user/OrderCanceling.vue'),
        props: true,
        meta: {
          title: '订单取消中',
          permission: ['user']
        }
      },
      {
        path: 'students',
        name: 'UserStudents',
        component: () => import('../views/user/Students.vue'),
        meta: {
          title: '学员管理',
          permission: ['user']
        }
      },
      {
        path: 'student-edit',
        name: 'UserStudentEdit',
        component: () => import('../views/user/StudentEdit.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '学员编辑',
          permission: ['user']
        }
      },
      {
        path: 'course/:id',
        name: 'UserCourse',
        component: () => import('../views/user/StudentCourse.vue'),
        props: true,
        meta: {
          title: '课程',
          permission: ['user']
        }
      },
      {
        path: 'collection',
        name: 'UserCollection',
        component: () => import('../views/user/Collection.vue'),
        meta: {
          title: '课程安排',
          permission: ['user']
        }
      },
      {
        path: 'notice',
        name: 'UserNotice',
        component: () => import('../views/user/Notice.vue'),
        props: true,
        meta: {
          title: '通知列表',
          permission: ['user']
        }
      },
      {
        path: 'notice-item',
        name: 'UserNoticeItem',
        component: () => import('../views/user/NoticeItem.vue'),
        props: true,
        meta: {
          title: '对话详情',
          permission: ['user']
        }
      },
      {
        path: 'drawal-record',
        name: 'UserDrawalRecode',
        component: () => import('../views/user/DrawalRecode.vue'),
        props: true,
        meta: {
          title: '提现记录',
          permission: ['user']
        }
      },
      {
        path: 'popularize',
        name: 'UserPromotion',
        component: () => import('../views/user/Promotion.vue'),
        meta: {
          keepAlive: true,
          title: '推广',
          keywords: '推广',
          description: '推广'
        }
      },
      {
        path: 'promote-withdrawal',
        name: 'UserPromoteWithDrawal',
        component: () => import('../views/user/PromoteWithdrawal.vue'),
        meta: {
          title: '推广提现',
          permission: ['user']
        }
      },
      {
        path: 'promote-withdrawal-record',
        name: 'UserPromoteWithdrawalRecord',
        component: () => import('../views/user/PromoteWithdrawalRecord.vue'),
        meta: {
          title: '推广提现记录',
          permission: ['user']
        }
      },
      {
        path: 'promote-returns-detailed',
        name: 'UserPromoteReturnsDetailed',
        component: () => import('../views/user/PromoteReturnsDetailed.vue'),
        meta: {
          title: '收益明细',
          permission: ['user']
        }
      },
      {
        path: 'my-article',
        name: 'UserMyArticle',
        component: () => import('../views/user/MyArticle.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的文章',
          permission: ['user']
        }
      },
      {
        path: 'article-post',
        name: 'UserArticlePost',
        component: () => import('../views/user/ArticlePost.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '发表文章',
          permission: ['user']
        }
      },
      {
        path: 'course-arrangement',
        name: 'UserCourseArrangement',
        component: () => import('../views/user/CourseArrangement.vue'),
        props: (route) => ({ student_id: parseInt(route.query.student_id) }),
        meta: {
          title: '课程安排',
          permission: ['user']
        }
      }
    ]
  },
  {
    path: '/teacher',
    component: RouteView,
    redirect: '/teacher/index',
    meta: { permission: ['teacher'] },
    children: [
      {
        path: 'index',
        name: 'TeacherIndex',
        component: () => import('../views/teacher/Index.vue'),
        meta: {
          title: '教员基本信息',
          permission: ['teacher']
        }
      },
      {
        path: 'members-apply',
        name: 'TeacherMembersApply',
        component: () => import('../views/teacher/MembersApply.vue'),
        meta: {
          title: '教员申请',
          permission: ['teacher']
        }
      },
      {
        path: 'workorder',
        name: 'TeacherWorkOrder',
        component: () => import('../views/teacher/WorkOrder.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '工单',
          permission: ['teacher']
        }
      },
      {
        path: 'workorderdetails/:id',
        name: 'TeacherWorkOrderDetails',
        component: () => import('../views/teacher/WorkOrderDetails.vue'),
        props: true,
        meta: {
          title: '工单详情',
          permission: ['teacher']
        }
      },
      {
        path: 'worksheet-post',
        name: 'TeacherWorksheetPost',
        component: () => import('../views/teacher/WorksheetPost.vue'),
        meta: {
          title: '新建工单',
          permission: ['teacher']
        }
      },
      {
        path: 'popularize',
        name: 'TeacherPromotion',
        component: () => import('../views/teacher/Promotion.vue'),
        meta: {
          keepAlive: true,
          title: '推广',
          keywords: '推广',
          description: '推广'
        }
      },
      {
        path: 'promote-withdrawal',
        name: 'TeacherPromoteWithDrawal',
        component: () => import('../views/teacher/PromoteWithdrawal.vue'),
        meta: {
          title: '推广提现',
          permission: ['teacher'] // 限制教员登录之后才能访问该页面
        }
      },
      {
        path: 'account-income',
        name: 'TeacherAccountIncome',
        component: () => import('../views/teacher/AccountIncome.vue'),
        props: true,
        meta: {
          title: '账户收益',
          permission: ['teacher']
        }
      },
      {
        path: 'withdrawal',
        name: 'TeacherWithdrawal',
        component: () => import('../views/teacher/Withdrawal.vue'),
        props: true,
        meta: {
          title: '收益提现',
          permission: ['teacher']
        }
      },
      {
        path: 'withdrawal-record',
        name: 'TeacherWithdrawalRecord',
        component: () => import('../views/teacher/WithdrawalRecord.vue'),
        props: true,
        meta: {
          title: '教员提现记录',
          permission: ['teacher']
        }
      },
      {
        path: 'income-details',
        name: 'TeacherIncomeDetails',
        component: () => import('../views/teacher/IncomeDetails.vue'),
        props: true,
        meta: {
          title: '收益记录',
          permission: ['teacher']
        }
      },
      {
        path: 'setting',
        name: 'TeacherSetting',
        component: () => import('../views/teacher/Setting.vue'),
        meta: {
          title: '设置',
          permission: ['teacher']
        }
      },
      {
        path: 'setting-email',
        name: 'TeacherSettingEmail',
        component: () => import('../views/teacher/SettingEmail.vue'),
        meta: {
          title: '绑定邮箱',
          permission: ['teacher']
        }
      },
      {
        path: 'setting-phone',
        name: 'TeacherSettingPhone',
        component: () => import('../views/teacher/SettingPhone.vue'),
        meta: {
          title: '绑定手机',
          permission: ['teacher']
        }
      },
      {
        path: 'setting-wechat',
        name: 'TeacherSettingWechat',
        component: () => import('../views/teacher/SettingWechat.vue'),
        meta: {
          title: '绑定微信',
          permission: ['teacher']
        }
      },
      {
        path: 'realname',
        name: 'TeacherSettingRealname',
        component: () => import('../views/teacher/SettingRealname.vue'),
        meta: {
          title: '实名认证',
          permission: ['teacher']
        }
      },
      {
        path: 'setting-password',
        name: 'TeacherSettingPassword',
        component: () => import('../views/teacher/SettingPassword.vue'),
        meta: {
          title: '设置密码',
          permission: ['teacher']
        }
      },
      {
        path: 'profile',
        name: 'TeacherProfile',
        component: () => import('../views/teacher/Profile.vue'),
        meta: {
          title: '个人信息',
          permission: ['teacher']
        }
      },
      {
        path: 'order',
        name: 'TeacherOrder',
        component: () => import('../views/teacher/Order.vue'),
        props: (route) => ({
          page: parseInt(route.query.page),
          status: route.query.status
        }),
        meta: {
          title: '用户订单列表',
          permission: ['teacher']
        }
      },
      {
        path: 'order-details/:ordernum',
        name: 'TeacherOrderDetails',
        component: () => import('../views/teacher/OrderDetails.vue'),
        props: (route) => ({ ordernum: route.params.ordernum }), // 解耦合
        meta: {
          title: '订单详情',
          permission: ['teacher']
        }
      },
      {
        path: 'order-cancel/:ordernum',
        name: 'TeacherOrderCancel',
        component: () => import('../views/teacher/OrderCancel.vue'),
        props: true,
        meta: {
          title: '订单取消申请',
          permission: ['teacher']
        }
      },
      {
        path: 'order-canceling/:ordernum',
        name: 'TeacherOrderCanceling',
        component: () => import('../views/teacher/OrderCanceling.vue'),
        props: true,
        meta: {
          title: '订单取消中',
          permission: ['teacher']
        }
      },
      {
        path: 'apply',
        name: 'TeacherApply',
        component: () => import('../views/teacher/Apply.vue'),
        meta: {
          title: '成为教员',
          permission: ['teacher']
        }
      },
      {
        path: 'serverpack',
        name: 'TeacherServerPack',
        component: () => import('../views/teacher/ServerPack.vue'),
        meta: {
          title: '服务包',
          permission: ['teacher']
        }
      },
      // {
      //   path: 'pack-info/:id',
      //   name: 'TeacherPackInfo',
      //   component: () => import('../views/teacher/PackInfo.vue'),
      //   props: (route) => ({ id: route.params.id }),
      //   meta: {
      //     title: '服务包管理',
      //     permission: ['teacher']
      //   }
      // },
      {
        path: 'pack-info',
        name: 'TeacherPackInfo',
        // 访问链接，给哪个页面显示
        component: () => import('../views/teacher/PackInfo.vue'),
        // 将路由传的值（ID）转化到props中,用props来接收
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '服务包管理',
          permission: ['teacher']
        }
      },
      {
        path: 'promote-withdrawal',
        name: 'TeacherPromoteWithDrawal',
        component: () => import('../views/teacher/PromoteWithdrawal.vue'),
        meta: {
          title: '推广提现',
          permission: ['teacher'] // 限制教员登录之后才能访问该页面
        }
      },
      {
        path: 'promote-withdrawal-record',
        name: 'TeacherPromoteWithdrawalRecord',
        component: () => import('../views/teacher/PromoteWithdrawalRecord.vue'),
        meta: {
          title: '推广提现记录',
          permission: ['teacher']
        }
      },
      {
        path: 'promote-returns-detailed',
        name: 'TeacherPromoteReturnsDetailed',
        component: () => import('../views/teacher/PromoteReturnsDetailed.vue'),
        meta: {
          title: '收益明细',
          permission: ['teacher']
        }
      },
      {
        path: 'my-article',
        name: 'TeacherMyArticle',
        component: () => import('../views/teacher/MyArticle.vue'),
        props: (route) => ({
          page: route.query.page,
          status: route.query.status
        }),
        meta: {
          title: '我的文章',
          permission: ['teacher']
        }
      },
      {
        path: 'article-post',
        name: 'TeacherArticlePost',
        component: () => import('../views/teacher/ArticlePost.vue'),
        props: (route) => ({ id: route.query.id }),
        meta: {
          title: '发表文章',
          permission: ['teacher']
        }
      },
      {
        path: 'course-arrangement',
        name: 'TeacherCourseArrangement',
        component: () => import('../views/teacher/CourseArrangement.vue'),
        meta: {
          title: '课程安排',
          permission: ['teacher']
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    // 首页
    path: '/',
    name: 'Index',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Index.vue'),
    meta: {
      keepAlive: true,
      title: '首页',
      keywords: '家教,小橙家教网,小橙教育,小橙家教平台',
      description: '小橙家教网致力于构建安全的、优质的、可信任的家教体系'
    }
  },
  {
    // 修改城市
    path: '/change-city',
    name: 'ChangeCity',
    component: () => import('../views/ChangeCity.vue'),
    meta: {
      title: '修改城市',
      keywords: '城市,位置,修改城市'
    }
  },
  {
    path: '/promote',
    name: 'Promote',
    component: () => import('../views/promote.vue')
  },
  {
    path: '/tubiao',
    name: 'TuBiao',
    component: () => import('../views/tubiao/TuBiao.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: RouteView,
    meta: { title: '首页' },
    redirect: '/account/user-login',
    children: [
      {
        path: 'user-login',
        name: 'UserLogin',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserLogin.vue'
          ),
        meta: { title: '用户登录', keepAlive: false }
      },
      {
        path: 'user-register',
        name: 'UserRegister',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRegister.vue'
          ),
        props: (route) => ({ promo_code: route.query.promo_code }),
        meta: { title: '用户注册', keepAlive: false }
      },
      {
        path: 'user-retrieve-pass',
        name: 'UserRetrievePass',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRetrievePass.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'user-retrieve-pass-email',
        name: 'UserRetrievePassEmail',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/user_account/UserRetrievePassEmail.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'user-reset-pass',
        name: 'UserResetPass',
        component: () => import('../views/user_account/UserResetPass.vue'),
        // props: (route) => ({ change_pass_token: route.query.change_pass_token }),
        props: (route) => ({
          change_pass_token: route.query.change_pass_token
        }),
        meta: { title: '用户重置密码', keepAlive: false }
      },
      // 教员账户
      {
        path: 'teacher-login',
        name: 'TeacherLogin',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherLogin.vue'
          ),
        meta: { title: '用户登录', keepAlive: false }
      },
      {
        path: 'teacher-register',
        name: 'TeacherRegister',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRegister.vue'
          ),
        props: (route) => ({ promo_code: route.query.promo_code }),
        meta: { title: '用户注册', keepAlive: false }
      },
      {
        path: 'teacher-retrieve-pass',
        name: 'TeacherRetrievePass',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRetrievePass.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'teacher-retrieve-pass-email',
        name: 'TeacherRetrievePassEmail',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/teacher_account/TeacherRetrievePassEmail.vue'
          ),
        meta: { title: '用户忘记密码', keepAlive: false }
      },
      {
        path: 'teacher-reset-pass',
        name: 'TeacherResetPass',
        component: () =>
          import('../views/teacher_account/TeacherResetPass.vue'),
        props: (route) => ({
          change_pass_token: route.query.change_pass_token
        }),
        meta: { title: '用户重置密码', keepAlive: false }
      }
    ]
  },
  {
    path: '/tutor',
    component: RouteView,
    redirect: '/tutor/list',
    children: [
      {
        path: 'list',
        name: 'TutorList',
        component: () => import('../views/tutor/List.vue'),
        props: (route) => ({
          page: route.query.page,
          week_day: route.query.week_day,
          area: route.query.area,
          sex: route.query.sex,
          category: route.query.category,
          course: route.query.course
        }),
        meta: {
          title: '找家教',
          keywords: '找家教,家教服务',
          description: '筛选符合条件的家教服务'
        }
      },
      {
        path: 'info/:id',
        name: 'TutorInfo',
        component: () => import('../views/tutor/Info.vue'),
        props: true,
        meta: {
          title: '服务包详情',
          keywords: '服务包,家教服务,价格'
        }
      },
      {
        path: 'pay/:id',
        name: 'TutorPay',
        component: () => import('../views/tutor/Pay.vue'),
        props: true,
        meta: {
          title: '支付',
          keywords: '支付页面'
        }
      }
    ]
  },
  {
    path: '/reveal',
    component: RouteView,
    redirect: '/reveal/list',
    children: [
      {
        path: 'list',
        name: 'RevealList',
        component: () => import('../views/reveal/List.vue'),
        props: (route) => ({
          page: route.query.page,
          area: route.query.area,
          type: route.query.type,
          sex: route.query.sex,
          school: route.query.school,
          teacher_id: route.query.teacher_id
        }),
        meta: {
          title: '教员风采'
        }
      },
      {
        path: 'info/:id',
        name: 'RevealInfo',
        component: () => import('../views/reveal/Info.vue'),
        props: true,
        meta: {
          title: '教员展示'
        }
      }
    ]
  },
  {
    // 论坛
    path: '/forum',
    component: RouteView,
    redirect: '/forum/list',
    children: [
      {
        path: 'list',
        name: 'ForumList',
        component: () =>
          import(/* webpackChunkName: "about" */ '@/views/forum/List.vue'),
        meta: {
          title: '论坛列表'
        }
      },
      {
        path: 'info/:id',
        name: 'ForumInfo',
        component: () => import('../views/forum/Info.vue'),
        props: true,
        meta: {
          title: '帖子详情'
        }
      },
      {
        path: 'inside',
        name: 'ForumInside',
        component: () => import('../views/forum/Inside.vue'),
        meta: {
          title: '论坛内页'
        }
      }
    ]
  },
  // 新闻与公告
  {
    path: '/news-announcements',
    name: 'News',
    component: () => import('../views/news-announcements/News.vue'),
    meta: {
      keepAlive: true,
      title: '新闻与公告',
      keywords: '新闻与公告',
      description: '新闻与公告'
    }
  },
  // 帮助中心
  {
    path: '/help-center',
    name: 'Help',
    component: () => import('../views/help-center/Help.vue'),
    meta: {
      keepAlive: true,
      title: '帮助中心',
      keywords: '帮助中心',
      description: '帮助中心'
    }
  },
  {
    path: '/help-center/:id',
    name: 'HelpItem',
    component: () => import('../views/help-center/Item.vue'),
    meta: {
      keepAlive: true,
      title: '帮助中心',
      keywords: '帮助中心',
      description: '帮助中心'
    },
    props: true
  },
  {
    // 文章legal-agreement
    path: '/article',
    component: RouteView,
    redirect: '/article/list',
    children: [
      {
        path: 'list',
        name: 'ArticleList',
        component: () => import('@/views/article/List.vue'),
        props: (route) => ({ page: route.query.page }),
        meta: {
          title: '其他文章'
        }
      },
      {
        path: 'info/:id',
        name: 'ArticleInfo',
        component: () => import('@/views/article/Info.vue'),
        props: true,
        meta: {
          title: '文章详情'
        }
      }
    ]
  },
  // 订单
  {
    path: '/order-form',
    name: 'Indent',
    component: () => import('../views/order-form/Indent.vue'),
    meta: {
      keepAlive: true,
      title: '订单详情',
      keywords: '订单详情',
      description: '订单详情'
    }
  },
  {
    path: '/404',
    name: '404',
    component: () =>
      import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]

/**
 * 默认路由
 */
export const defaultRoutePath = '/'

/**
 * 白名单：不需要授权可访问的列表
 * @type { *[] }
 */
export const whiteList = [
  'Index',
  'UserLogin',
  'UserRegister',
  'UserRetrievePass',
  'UserRetrievePassEmail',
  'UserResetPass',
  'TeacherLogin',
  'TeacherRegister',
  'TeacherRetrievePass',
  'TeacherRetrievePassEmail',
  'TeacherResetPass',
  'RevealList',
  'RevealInfo',
  'ForumList',
  'ForumInfo',
  'News',
  'Help',
  'Indent',
  'HelpItem',
  'TutorList',
  'TutorInfo',
  'TuBiao',
  'Promote',
  'ChangeCity',
  'Test',
  'ArticleList',
  'ArticleInfo'
]

/**
 * 登录后不能访问的页面
 * @type { *[] }
 */
export const loginCannotAccess = [
  'UserLogin',
  'UserRegister',
  'UserRetrievePass',
  'UserRetrievePassEmail',
  'UserResetPass',
  'TeacherLogin',
  'TeacherRegister',
  'TeacherRetrievePass',
  'TeacherRetrievePassEmail',
  'TeacherResetPass'
]
